export default __webpack_public_path__ + "0bfc60c5a599d0af730ac64deaa1da1b.ply";